/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faTwitter,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import {
  faTowerBroadcast,
  faPlaneDeparture,
  faServer,
  faUserShield,
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import rogers from '../../assets/images/rogers.jpeg';
import matovu from '../../assets/images/matovu.jpeg';
import annabel from '../../assets/images/annabel.jpg';
import blankpic from '../../assets/images/blankpic.png';

function Team() {
  return (
    <div className="xl:mx-24 lg:m-16 md:m-8 m-4">
      <h1 className="md:text-3xl text-xl text-center font-bold my-3">The DANS SMS Team</h1>
      <ul className="md:my-8 my-2 flex md:flex-nowrap flex-wrap justify-around md:gap-6 gap-3 w-full">
        {[
          {
            name: 'Mr. David Matovu',
            role: 'Manager SMS',
            img: matovu,
            facebook: 'https://www.facebook.com/david.matovu.712',
            twitter: '/',
            linkedin: 'https://www.linkedin.com/in/david-matovu-56143068/',
          },
          {
            name: 'Mr. Rogers Wanzunula',
            role: 'PAIMO SMS/QA',
            img: rogers,
            facebook: 'https://www.facebook.com/wanzunula',
            twitter: 'https://twitter.com/Wanz_u',
            linkedin: 'https://www.linkedin.com/in/rogers-wanzunula-29085250/',
          },
          {
            name: 'Ms. Madina Ndagire',
            role: 'ATM/SAR/SMS Expert',
            img: blankpic,
            facebook: '/',
            twitter: '/',
            linkedin: '/',
          },
          {
            name: 'Mr. Micheal Kasirye',
            role: 'PTO SMS/QA',
            img: blankpic,
            facebook: '/',
            twitter: '/',
            linkedin: '/',
          },
          {
            name: 'Ms. Annabel Acipa',
            role: 'Ag. PATMO SMS/QA',
            img: annabel,
            facebook: 'https://www.facebook.com/apwoyrwot/',
            twitter: '/',
            linkedin: 'https://www.linkedin.com/in/annabel-acipa-acipa-5444009b/',
          },
        ].map((member) => (
          <li key={member.name} className="md:w-1/4 w-2/5 flex flex-col items-center bg-gray-100 hover:bg-yellow-100 md:p-4 p-2 rounded-lg shadow-md transition-all duration-200">
            <img
              src={member.img}
              alt={`DANS SMS Team - ${member.name}`}
              className="rounded-full w-2/3 mt-4 mb-2"
            />
            <h2 className="font-bold xl:text-lg md:text-md text-xs my-1">{member.name}</h2>
            <h3 className="text-gray-400 md:text-md text-xs">{member.role}</h3>
            <ul className="flex justify-around lg:gap-8 gap-4 lg:text-xl mt-2">
              <li>
                <Link to={member.facebook}>
                  <FontAwesomeIcon className="text-blue-500" icon={faFacebook} />
                </Link>
              </li>
              <li>
                <Link to={member.twitter}>
                  <FontAwesomeIcon className="text-sky-500" icon={faTwitter} />
                </Link>
              </li>
              <li>
                <Link to={member.linkedin}>
                  <FontAwesomeIcon className="text-blue-500" icon={faLinkedin} />
                </Link>
              </li>
            </ul>
          </li>
        ))}
      </ul>
      <ul className="flex lg:justify-between justify-center items-center w-full gap-4 md:m-4 m-2 md:my-12 my-6 lg:flex-nowrap flex-wrap">
        <li className="xl:text-2xl text-xl text-gray-400 mr-6 my-3">
          {'ANS '}
          <span className="font-semibold xl:text-2xl text-xl text-gray-600">Departments</span>
        </li>
        {[
          {
            icon: faTowerBroadcast,
            text: 'Air Traffic Management',
          },
          {
            icon: faPlaneDeparture,
            text: 'Aeronautical Information Management',
          },
          {
            icon: faServer,
            text: 'Communication Navigation and Surveillance',
          },
          {
            icon: faUserShield,
            text: 'Safety Management Systems',
          },
        ].map((dept) => (
          <li key={dept.icon} className="flex justify-center gap-3 items-center xl:text-xl md:text-md text-sm text-gray-700 font-bold">
            <FontAwesomeIcon className="xl:text-xl text-lg" icon={dept.icon} />
            <p>{dept.text}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Team;
